import { SelectField } from './ui';

/** "After round N" picker for standings and the crosstable. */
export function RoundSelect({
  rounds,
  value,
  onValue,
}: {
  rounds: number;
  value: number;
  onValue: (round: number) => void;
}) {
  const options = [];
  for (let r = rounds; r >= 1; r--) options.push({ value: String(r), label: `Round ${r}` });
  return (
    <SelectField
      className="round-select no-print"
      label="After round"
      value={String(value)}
      onValue={(v) => onValue(Number(v))}
      options={options}
    />
  );
}
